import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { KapDetails } from './KapDetails.js';
export class CreateKapIndividualRequest extends BaseMessage {
    kapDetails;
    owner;
}
__decorate([
    Field.array({
        description: 'KAP Details of the directors of the  organisation',
        items: {
            type: 'message',
            message: KapDetails,
        },
    }),
    __metadata("design:type", Array)
], CreateKapIndividualRequest.prototype, "kapDetails", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], CreateKapIndividualRequest.prototype, "owner", void 0);
//# sourceMappingURL=CreateKapIndividualRequest.js.map